import throttle from 'lodash/throttle';
import { loadState, saveState } from './localStorage';
import { configureStore } from '@reduxjs/toolkit';
import type { RootState } from './reducers';
import rootReducer from './reducers';
import { isProdEnv } from './environment';
import { canvasLayersInitialState } from './reducers/canvasLayersReducer';
import { metadataMappingPersistedStateHandler } from './components/pages/canvas-pages/united-canvas/process-mining/metadataMappingPersistence';

const persistedState = loadState();
export const storeBuilder = (preloadedState?: RootState) => {
  const store = configureStore({
    reducer: rootReducer,
    preloadedState: preloadedState || persistedState,
    devTools: !isProdEnv,
  });

  store.subscribe(
    throttle(() => {
      // If you want to persist state variables in local storage
      // here is the place:
      const persistedStateOnLocalStorage = {
        debugInfo: store.getState().debugInfo,
        canvasLayersV2: { ...canvasLayersInitialState, ...store.getState().canvasLayersV2 },
        templateFieldsMapping: store.getState().templateFieldsMapping,
        metadataMapping: metadataMappingPersistedStateHandler(store.getState().metadataMapping),
      };
      saveState(persistedStateOnLocalStorage);
    }, 1000),
  );

  return { store };
};
